export const APPOINTIA_VERSION = require('../modules/version/components/version/version.json').version as string;
